import {
  Input,
  MultiSearchForm,
  Select,
  singleBooleanOptions,
  useCategoriesQuery,
  useEnabledProjectsQuery,
  useProjectsAttributesQuery,
} from "@";
import type { DonationsSearchValues } from "../types.ts";
import React from "react";

interface MultiSearchProps {
  onSubmit: () => void;
  search: {
    show: boolean;
    values: DonationsSearchValues;
  };
  updateSearch: (params: {
    show?: boolean;
    values?: DonationsSearchValues;
  }) => void;
  onReset: () => void;
}

const MultiSearch = ({
  onSubmit,
  search,
  updateSearch,
  onReset,
}: MultiSearchProps) => {
  const classificationId = search.values.projectClassificationId
    ? parseInt(search.values.projectClassificationId as string)
    : null;

  // Fetch projects using React Query
  const { data: projects = [] } = useEnabledProjectsQuery(classificationId);

  // Fetch categories using React Query
  const { data: categories = [] } = useCategoriesQuery();

  // Fetch project attributes using React Query
  const { data: projectAttributes = [] } = useProjectsAttributesQuery(
    search.values.projectIds,
  );

  const handleInputChange = (
    field: keyof DonationsSearchValues,
    value: unknown,
  ) => {
    updateSearch({
      values: { ...search.values, [field]: value },
    });
  };

  return (
    <MultiSearchForm
      show={search.show}
      onSubmit={onSubmit}
      reset={onReset}
      className="multi-search-form lg:grid-cols-4"
    >
      <Input
        style="xl:col-span-2"
        change={(e: { target: { value: string } }) =>
          handleInputChange("searchKey", e.target.value)
        }
        value={search.values.searchKey}
        label="ابحث باسم العميل أو الجوال أو رقم الطلب"
        star
      />

      {/* stageName */}
      <Input
        star
        label=" المرحلة"
        value={search.values.stageName}
        change={(e: { target: { value: string } }) =>
          handleInputChange("stageName", e.target.value)
        }
      />

      <Input
        change={(e: React.ChangeEvent<HTMLSelectElement>) =>
          handleInputChange("isFirstStageVerified", e.target.value)
        }
        type="select"
        list={singleBooleanOptions}
        value={search.values.isFirstStageVerified}
        label="تم توثيق المرحلة الأولى"
        star
      />

      {/* Input for selecting date */}
      <Input
        star
        showTimeSelect
        style="xl:col-span-2"
        type="date-range"
        labelA="تاريخ الإنشاء من"
        labelB="تاريخ الإنشاء الي"
        valueB={search.values.toTime}
        valueA={search.values.fromTime}
        changeA={(e: string) => handleInputChange("fromTime", e)}
        changeB={(e: string) => handleInputChange("toTime", e)}
      />

      {/* Input for selecting date */}
      <Input
        star
        showTimeSelect
        style="xl:col-span-2"
        type="date-range"
        labelA="تاريخ التنفيذ من "
        labelB="تاريخ التنفيذ الي"
        valueB={search.values.smsSendingDateTimeTo}
        valueA={search.values.smsSendingDateTimeFrom}
        changeA={(e: string) => handleInputChange("smsSendingDateTimeFrom", e)}
        changeB={(e: string) => handleInputChange("smsSendingDateTimeTo", e)}
      />

      {/* projectClassificationId */}
      <Input
        star
        label="تصنيف المشروع"
        list={categories}
        type="select-searchable"
        value={categories?.filter(
          (c) => search.values.projectClassificationId == String(c.value),
        )}
        change={(e: { value: number } | null) =>
          handleInputChange("projectClassificationId", e ? String(e.value) : "")
        }
      />

      <div className="lg:col-span-2">
        <label className="input-label">المشروع</label>
        <Select
          value={projects.filter((c) =>
            search.values?.projectIds?.includes(c.value),
          )}
          placeholder=""
          onChange={(val) => {
            const values = val as unknown as { value: number }[];
            handleInputChange(
              "projectIds",
              values.map((c) => c.value),
            );
          }}
          options={projects}
          isMulti
        />
      </div>

      {/*{search.values.projectIds?.length > 0 && (*/}
      {/*)}*/}
      <Input
        star
        label="فئة المشروع"
        list={projectAttributes}
        disabled={search.values.projectIds?.length === 0}
        placeholder={
          search.values.projectIds?.length ? "" : "إختر المشروع اولاً "
        }
        type="select-searchable"
        value={projectAttributes?.filter(
          (c) => search.values.projectAttributeId == String(c.value),
        )}
        change={(e: { value: number } | null) =>
          handleInputChange("projectAttributeId", e ? String(e.value) : "")
        }
      />
    </MultiSearchForm>
  );
};

export default MultiSearch;
